var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftArrowGarageName(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 10,
    viewBox: "0 0 63 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55 5H0",
    stroke: "url(#leftArrowGarageName_svg__paint0_linear_9108_31742)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M57.863 9.83c-.574-2.013-2.672-4.103-4.693-4.675-.227-.073-.227-.233 0-.31 2.025-.575 4.12-2.661 4.697-4.678.062-.223.212-.223.274 0 .574 2.017 2.672 4.103 4.689 4.679.227.073.227.236 0 .31-2.021.57-4.12 2.661-4.693 4.675-.062.225-.212.225-.274 0z",
    fill: "#7F41D1"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "leftArrowGarageName_svg__paint0_linear_9108_31742",
    x1: 55,
    y1: 5.5,
    x2: 0,
    y2: 5.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7F41D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#41216B",
    stopOpacity: 0
  })))));
}
export default SvgLeftArrowGarageName;